import React from 'react';
import {connect} from 'react-redux';
// Components
import Header from 'Components/common/Header';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import ProxyDeliveryReceivePackageCard from 'Components/host/proxyDeliveryManagement/ProxyDeliveryReceivePackageCard';
import ProxyDeliveryReject from 'Components/host/proxyDeliveryManagement/ProxyDeliveryReject';
import ProxyDeliveryStatusTracking from 'Components/host/proxyDeliveryManagement/ProxyDeliveryStatusTracking';
import SearchInput from 'Components/common/SearchInput';
import LoadingIcon from 'Components/icons/LoadingIcon';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import util from 'Utils/commonUtil';
import {RECEIVE_METHOD, PROXY_DELIVERY_ORDER_STATUS} from 'Utils/constant';

// Actions
import {openNotification} from 'Actions/notification';
import {viewOrderTracking, uploadReceiveImage} from 'Actions/host';
import {
    viewProxyDeliveryPackage,
    clearProxyDeliveryPackageData,
    updateProxyDeliveryPackageReceiveSearchFileld,
    receiveProxyDeliveryPackage,
    setProxyDeliveryOrderSource,
    updateProxyDeliveryOrderTabActive,
    getSysDict,
    rejectProxyDeliveryPackage,
    getSysDictByRejectReason,
} from 'Actions/proxyDelivery';
import {T} from 'Actions/translate';
import {
    PROXY_DELIVERY_ORDER_TAB_FLAG,
    PROXY_DELIVERY_RECEIVE_TYPE,
} from 'Utils/constant';

class ProxyDeliveryForPackageReceive extends React.Component {
    state = {
        productsReceivingQuantity: [],
        receiveBtnsIsLoading: [],
        receiveAllBtnIsLoading: false,
        exitOpened: false,
        receiveExitOpened: false,
        isAllReceive: false,
        productQuantity: [],
        currentItem: null,
        currentIndex: 0,
        checked: true,
        defaultCheck: null,
        currentProductIds: [],
        allReceiveOrderArry: [],
        f1OrderReceiveList: [],
        orderNumber: '',
        proxyDeliveryForPackageReceivedList: {},
        allF1WaitShippedList: {},
        f1WaitShippedList: {},
        f1ReceivedList: {},
        packageStatus: 'toBeReceived',
        f1PackageReceivePageLoad: true,
        cancelReceivePackageDialogOpened: false,
        receivePackageRemark: '',
        receiveQuantity: 0,
        activeStep: 0,
        trackAndTraceLogsArry: [],
        stepsDescriptionArry: [],
        stepsTimeArry: [],
        currentCarrierName: '',
        receiveMethod: RECEIVE_METHOD.CUSTOMER,
        chooseImage: null,
        uploadFileBtnIsLoading: false,
        signReceiptUploadImage: null,
        signReceiptUploadDialogOpened: false,
        rejectPackageDialogOpened: false,
        rejectReasonOptions: [],
        rejectPackageBtnIsLoading: false,
        rejectDialogResetKey: 0,
    };

    inputFileRef = React.createRef();

    onChooseImage = () => {
        if (this.inputFileRef && this.inputFileRef.current) {
            this.inputFileRef.current.click();
        }
    };

    onSelectedImage = (ev) => {
        const file =
            ev && ev.target && ev.target.files ? ev.target.files[0] : null;
        if (!file) return;

        const fileName = file.name || '';
        const isImageType =
            (file.type && /^image\//i.test(file.type)) ||
            (!file.type && /\.svg$/i.test(fileName));

        if (!isImageType) {
            this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (loadEvent) => {
            const url =
                loadEvent && loadEvent.target ? loadEvent.target.result : '';
            this.setState({
                chooseImage: {
                    file,
                    url,
                },
            });
        };

        reader.readAsDataURL(file);
    };
    componentDidMount() {
        let routerState = this.getRouterState();
        this.props.getSysDict('PROXY_DELIVERY_SHIPMENT_STATUS');
        let rejectType = '';
        if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            rejectType = 'PROXY_DELIVERY_HOST_REJECT_REASON';
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING
        ) {
            rejectType = 'PROXY_DELIVERY_CUSTOMER_REJECT_REASON';
        }
        if (rejectType) {
            this.props.getSysDictByRejectReason(rejectType);
        }
    }

    componentDidUpdate(prevProps) {
        const {rejectReasonList} = this.props;
        if (prevProps.rejectReasonList !== rejectReasonList) {
            const reasonOptions =
                this.normalizeRejectReasonOptions(rejectReasonList);

            const hasDifferentOptions =
                JSON.stringify(reasonOptions) !==
                JSON.stringify(this.state.rejectReasonOptions);

            if (hasDifferentOptions) {
                this.setState({rejectReasonOptions: reasonOptions});
            }
        }
    }

    normalizeRejectReasonOptions = (options) => {
        if (!Array.isArray(options)) {
            return [];
        }

        return options
            .map((option) => {
                if (!option || typeof option !== 'object') {
                    return null;
                }

                const rawValue =
                    option.key ||
                    option.value ||
                    option.dictValue ||
                    option.code ||
                    option.id ||
                    '';
                const rawLabel =
                    option.label ||
                    option.dictLabel ||
                    option.name ||
                    option.value ||
                    rawValue;

                const normalizedLabel = rawLabel || rawValue;
                if (!normalizedLabel) {
                    return null;
                }

                const normalizedValue = rawValue || normalizedLabel;

                return {
                    id: normalizedValue,
                    key: normalizedValue,
                    value: normalizedValue,
                    name: normalizedLabel,
                    fullName: normalizedLabel,
                    label: normalizedLabel,
                    original: option,
                };
            })
            .filter(Boolean);
    };

    handleRejectPackage = (payload) => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        if (!payload) {
            return;
        }

        let routerState = this.getRouterState();
        const normalizedPayload = {
            ...payload,
            comment: (payload.remark || '').trim(),
            rejectType:
                routerState.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING
                    ? 'CUSTOMER_REJECTED'
                    : 'HOST_REJECTED',
            id: proxyDeliveryForPackageReceivedList.id,
        };

        this.props.rejectProxyDeliveryPackage(normalizedPayload).then((res) => {
            if (res && res.status === 'success') {
                this.props.openNotification(
                    T(T('proxy_delivery_reject_success')),
                );

                this.props.updateProxyDeliveryPackageReceiveSearchFileld({
                    queryKey: '',
                });

                this.props.setProxyDeliveryOrderSource({$set: false});

                this.props.updateProxyDeliveryOrderTabActive({
                    $set: 2,
                });
                this.props.history.replace('/proxyDeliveryOrderList');
            } else {
                return Promise.reject(res);
            }
        });
        this.setState(
            {
                pendingRejectPayload: {
                    ...normalizedPayload,
                },
            },
            () => {
                this.dialogDidClose('rejectPackageDialogOpened');
            },
        );
    };

    componentWillMount() {
        let routerState = this.getRouterState();
        this.props.updateProxyDeliveryPackageReceiveSearchFileld({
            queryKey: '',
        });
        this.getPackageReceive('');
        if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            this.viewOrderTracking();
        }
    }

    componentWillUnmount() {
        this.props.clearProxyDeliveryPackageData();
    }

    viewOrderTracking = () => {
        let routerState = this.getRouterState();
        let params = {
            shipmentNumber: routerState.shipmentNumber,
        };

        this.props.viewOrderTracking(params).then((res) => {
            if (res && res.status === 'success') {
                if (res.data.length > 0) {
                    let allTrackingLogsArry = [];
                    let tempCarrierName = '';

                    res.data.forEach((currentTracking) => {
                        let tempTrackAndTraceLogs = currentTracking.events;

                        tempCarrierName = currentTracking.carrierName;
                        if (tempTrackAndTraceLogs.length > 0) {
                            allTrackingLogsArry = allTrackingLogsArry.concat(
                                tempTrackAndTraceLogs,
                            );
                        }
                    });

                    let tempStepDescriptionArry = [];
                    let tempStepsTimeArry = [];
                    allTrackingLogsArry.length > 0 &&
                        allTrackingLogsArry.forEach((trackObj) => {
                            tempStepDescriptionArry.push(
                                trackObj.eventDescription,
                            );
                            tempStepsTimeArry.push(trackObj.eventDateTime);
                        });

                    this.setState({
                        trackAndTraceLogsArry: allTrackingLogsArry,
                        stepsDescriptionArry: tempStepDescriptionArry,
                        stepsTimeArry: tempStepsTimeArry,
                        currentCarrierName: tempCarrierName,
                    });
                }
            }
        });
    };

    onChange = (title, value) => {
        this.props.updateProxyDeliveryPackageReceiveSearchFileld({
            [title]: value,
        });
    };

    search = () => {
        this.setState({f1OrderReceiveList: []});
        this.getPackageReceive();
    };

    formatCustomerReceiveConfirmText = (text) => {
        if (!text) {
            return [];
        }

        return text
            .split(/；|;/)
            .map((segment) => segment.trim())
            .filter(Boolean)
            .map((segment) => {
                const colonMatch = segment.match(/[:：]/);

                if (!colonMatch) {
                    const punctuationMatch = segment.match(/[。.]$/);
                    const punctuation = punctuationMatch
                        ? punctuationMatch[0]
                        : '';
                    const leading = punctuation
                        ? segment.slice(0, -1).trim()
                        : segment;

                    return {
                        leading,
                        highlight: '',
                        punctuation,
                    };
                }

                const colonIndex = segment.indexOf(colonMatch[0]);
                const leadingRaw = segment.slice(0, colonIndex + 1).trim();
                const leading = `${leadingRaw} `;
                const afterColon = segment.slice(colonIndex + 1).trim();
                const punctuationMatch = afterColon.match(/[。.]$/);
                const punctuation = punctuationMatch ? punctuationMatch[0] : '';
                const highlight = punctuation
                    ? afterColon.slice(0, -1).trim()
                    : afterColon;

                return {
                    leading,
                    highlight,
                    punctuation,
                };
            });
    };

    getCurrentWaitShippedData = (queryKey) => {
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.allF1WaitShippedList),
        );

        let currentQueryKey = queryKey.trim();
        if (
            currentWaitReceiveList.waitShipSkus &&
            currentWaitReceiveList.waitShipSkus.length > 0
        ) {
            const waitShipSkus = currentWaitReceiveList.waitShipSkus;
            const currentWaitShippedSkuArrys = [];

            const escapeRegExp = (s) =>
                s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const reg = currentQueryKey
                ? new RegExp(escapeRegExp(currentQueryKey), 'ig')
                : null;

            waitShipSkus.forEach((waitShipItem) => {
                const currentItem = Object.assign({}, waitShipItem);
                if (!reg || (currentItem.sku && reg.test(currentItem.sku))) {
                    currentWaitShippedSkuArrys.push(currentItem);
                }
            });
            currentWaitReceiveList.waitShipSkus = currentWaitShippedSkuArrys;
        }
        this.setState({
            f1WaitShippedList: currentWaitReceiveList,
        });
    };
    getPackageReceive = (forceSku) => {
        let params = {};
        let routerState = this.getRouterState();
        let orderId = routerState.id;

        let currentSKU = '';
        if (forceSku !== undefined) {
            currentSKU = forceSku;
        } else if (this.props.queryKey) {
            currentSKU = this.props.queryKey;
        } else {
            if (this.props.queryKey && this.props.queryKey.trim()) {
                currentSKU = this.props.queryKey.trim();
            } else {
                currentSKU = '';
            }
        }

        params = {
            id: orderId,
            sku: currentSKU,
        };

        this.props
            .viewProxyDeliveryPackage(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    let waitReceiveList = res.data;
                    JSON.stringify(waitReceiveList) !== '{}' &&
                        waitReceiveList.products &&
                        waitReceiveList.products.length > 0 &&
                        res.data.products.forEach((packageProductItem) => {
                            packageProductItem.checked = true;
                        });
                    this.setState(
                        {
                            proxyDeliveryForPackageReceivedList:
                                waitReceiveList,
                            f1PackageReceivePageLoad: false,
                        },
                        () => {
                            this.showOrderNumber(waitReceiveList);
                        },
                    );
                } else if (res && res.status === 'SHIPMENT_NOT_EXIST') {
                    this.setState({
                        proxyDeliveryForPackageReceivedList: {},
                        f1PackageReceivePageLoad: false,
                    });
                }
            })
            .catch((res) => {
                this.setState({
                    f1PackageReceivePageLoad: false,
                    proxyDeliveryForPackageReceivedList: {},
                });
            });
    };

    getRouterState = () => {
        let routerState = '';
        if (this.props.history.location.state) {
            routerState = this.props.history.location.state;
        }
        return routerState;
    };

    isDisabledReceiveBtn = () => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let disabledBtn = false;
        if (proxyDeliveryForPackageReceivedList.status === 'COMPLETED') {
            disabledBtn = true;
        }
        return disabledBtn;
    };

    goBack = () => {
        this.props.setProxyDeliveryOrderSource({$set: true});
        const routerState = this.getRouterState();

        this.props.updateProxyDeliveryOrderTabActive({
            $set: routerState.tabActive,
        });
        this.props.history.goBack();
    };

    showOrderNumber = (orderList) => {
        let routerState = this.getRouterState();
        if (JSON.stringify(routerState) !== '{}') {
            let number = 0;
            if (routerState.orderStatus === 'toBeReceived') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'received') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'toBeShipped') {
                number = orderList.number;
            }
            this.setState({
                orderNumber: number,
            });
        }
    };

    allReceivePackage = () => {
        const {viewProxyDeliveryOrderPackageData} = this.props;
        if (this.getReceiveType() === PROXY_DELIVERY_RECEIVE_TYPE.CUSTOMER) {
            this.setState({
                cancelReceivePackageDialogOpened: true,
                uploadFileBtnIsLoading: false,
                chooseImage: null,
                receivePackageRemark:
                    (viewProxyDeliveryOrderPackageData &&
                        viewProxyDeliveryOrderPackageData.data &&
                        viewProxyDeliveryOrderPackageData.data.stRemark) ||
                    '',
            });
        } else if (this.getReceiveType() === PROXY_DELIVERY_RECEIVE_TYPE.HOST) {
            this.setState({
                cancelReceivePackageDialogOpened: true,
                receivePackageRemark: '',
            });
        }
    };

    openRejectPackageDialog = () => {
        this.setState({rejectPackageDialogOpened: true});
    };

    getReceiveType = () => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let routerState = this.getRouterState();
        let receiveType = PROXY_DELIVERY_RECEIVE_TYPE.HOST;

        if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING
        ) {
            receiveType = PROXY_DELIVERY_RECEIVE_TYPE.CUSTOMER;
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            receiveType = PROXY_DELIVERY_RECEIVE_TYPE.HOST;
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE
        ) {
            if (
                proxyDeliveryForPackageReceivedList.status ===
                PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED
            ) {
                receiveType = PROXY_DELIVERY_RECEIVE_TYPE.CUSTOMER;
            } else if (
                proxyDeliveryForPackageReceivedList.status ===
                PROXY_DELIVERY_ORDER_STATUS.HOST_REJECTED
            ) {
                receiveType = PROXY_DELIVERY_RECEIVE_TYPE.HOST;
            }
        }

        return receiveType;
    };

    getDialogTitle = (routerState) => {
        let dialogTitle = '';
        if (this.getReceiveType() === PROXY_DELIVERY_RECEIVE_TYPE.HOST) {
            dialogTitle = T('order_confirm_receive');
        } else if (
            this.getReceiveType() === PROXY_DELIVERY_RECEIVE_TYPE.CUSTOMER
        ) {
            dialogTitle = T('proxy_delivery_customer_receive');
        }
        return dialogTitle;
    };

    getReceiveSuccessNotification = (routerState) => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let notificationText = '';
        if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.IN_TRANSIT
        ) {
            notificationText = T('notification_successful_receipt_of_goods');
        } else if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.WAIT_CUSTOMER_RECEIPT
        ) {
            notificationText = T(
                'notification_customer_successful_receipt_of_goods',
            );
        } else if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.HOST_REJECTED
        ) {
            notificationText = T(
                'proxy_delivery_host_once_again_receive_success',
            );
        } else if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED
        ) {
            notificationText = T(
                'proxy_delivery_customer_once_again_receive_success',
            );
        }
        return notificationText;
    };

    confirmReceivePackageHandle = () => {
        let routerState = this.getRouterState();
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.proxyDeliveryForPackageReceivedList),
        );
        let allProducts = [];
        JSON.stringify(allReceivedList) !== '{}' &&
            allReceivedList.products.forEach((item) => {
                const currentItem = Object.assign({}, item);
                if (currentItem.checked) {
                    allProducts.push(currentItem);
                }
            });

        allReceivedList.products = allProducts;
        const {chooseImage} = this.state;
        this.setState({uploadFileBtnIsLoading: true});

        this.props
            .uploadReceiveImage({
                type: 'proxy_delivery',
                file: chooseImage ? chooseImage.file : null,
            })
            .then((res) => {
                if (!res || res.status !== 'success') {
                    return Promise.reject(res);
                }

                const receiveImgUrl =
                    res && res.url
                        ? res.url
                        : chooseImage
                        ? chooseImage.url
                        : null;
                const params = {
                    id: allReceivedList.id,
                    receiveImg: receiveImgUrl,
                    receiverType: this.getReceiveType(),
                };

                // console.log('params in confirmReceivePackageHandle:', params);
                return this.props.receiveProxyDeliveryPackage(params);
            })
            .then((res) => {
                if (res && res.status === 'success') {
                    this.props.openNotification(
                        this.getReceiveSuccessNotification(routerState),
                        'success',
                    );
                    this.getPackageReceive();

                    this.props.updateProxyDeliveryPackageReceiveSearchFileld({
                        queryKey: '',
                    });

                    this.props.setProxyDeliveryOrderSource({$set: false});

                    this.props.updateProxyDeliveryOrderTabActive({
                        $set: routerState.tabActive,
                    });

                    this.props.history.replace('/proxyDeliveryOrderList');

                    this.setState({
                        cancelReceivePackageDialogOpened: false,
                        receivePackageRemark: '',
                    });
                } else {
                    return Promise.reject(res);
                }
            })
            .catch((err) => {
                // keep dialog open and surface error feedback
                // this.props.openNotification(
                //     T('notification_goods_failed'),
                //     'danger',
                // );
            })
            .finally(() => {
                this.setState({uploadFileBtnIsLoading: false});
            });
    };

    dialogDidClose = (dialog) => {
        if (this.state[dialog]) {
            const extraState = {};

            if (dialog === 'cancelReceivePackageDialogOpened') {
                extraState.chooseImage = null;
            }

            if (dialog === 'rejectPackageDialogOpened') {
                extraState.rejectDialogResetKey =
                    this.state.rejectDialogResetKey + 1;
            }

            this.setState({[dialog]: false, ...extraState}, () => {
                if (
                    dialog === 'cancelReceivePackageDialogOpened' &&
                    this.inputFileRef &&
                    this.inputFileRef.current
                ) {
                    this.inputFileRef.current.value = '';
                }
            });
        }
    };

    getReceivePackageQuantity = () => {
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.proxyDeliveryForPackageReceivedList),
        );
        let checkedQuantity = 0;
        if (JSON.stringify(allReceivedList) !== '{}') {
            if (
                allReceivedList.products &&
                allReceivedList.products.length > 0
            ) {
                allReceivedList.products.forEach((receiveItem) => {
                    if (receiveItem.checked) {
                        ++checkedQuantity;
                    }
                });
            }
        }
        return checkedQuantity;
    };

    getStepContent = (step) => {
        let stepsTimeArry = this.state.stepsTimeArry;
        let stepTime = '';
        stepsTimeArry.length > 0 &&
            stepsTimeArry.forEach((stepTimeObj, stepTimeIndex) => {
                if (step === stepTimeIndex) {
                    stepTime = stepTimeObj;
                }
            });
        return stepTime;
    };

    isCustomerReceive = () => {
        let routerState = this.getRouterState();
        let isCustomerReceive = false;
        if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            isCustomerReceive = false;
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING
        ) {
            isCustomerReceive = true;
        }
        return isCustomerReceive;
    };

    getReceiveLabel = () => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let receiveLabel = '';

        if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.WAIT_CUSTOMER_RECEIPT
        ) {
            receiveLabel = T('proxy_delivery_customer_receive');
        } else if (
            proxyDeliveryForPackageReceivedList.status ===
            PROXY_DELIVERY_ORDER_STATUS.WAIT_CUSTOMER_RECEIPT
        ) {
            receiveLabel = T('proxy_delivery_go_on_receive');
        } else if (
            proxyDeliveryForPackageReceivedList.status ===
                PROXY_DELIVERY_ORDER_STATUS.HOST_REJECTED ||
            proxyDeliveryForPackageReceivedList.status ===
                PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED
        ) {
            receiveLabel = T('proxy_delivery_go_on_receive');
        } else {
            receiveLabel = T('shippment_take_goods');
        }
        return receiveLabel;
    };

    previewSignReceiptImage = (imageUrl) => {
        if (imageUrl) {
            this.setState(
                {
                    signReceiptUploadDialogOpened: true,
                    imageStream: imageUrl,
                },
                () => {
                    let img = new Image();
                    img.src = imageUrl;
                    img.id = 'adventImage';

                    if (document.getElementById('adventImage')) {
                        document.getElementById('adventImage').remove();
                    }
                    document.getElementById('testImage').appendChild(img);
                },
            );
        }
    };

    getTabStatusLabel = () => {
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let routerState = this.getRouterState();
        let statusLabel = '';
        if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            statusLabel = T('fone_order_on_the_parcel');
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING
        ) {
            statusLabel = T('proxy_delivery_received_awaiting_status');
        } else if (
            routerState.tabFlag ===
            PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE
        ) {
            if (
                proxyDeliveryForPackageReceivedList.status ===
                    PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED ||
                proxyDeliveryForPackageReceivedList.status ===
                    PROXY_DELIVERY_ORDER_STATUS.HOST_REJECTED
            ) {
                statusLabel = T('proxy_delivery_reject_label');
            } else {
                statusLabel = T('host_completed_status');
            }
        }
        return statusLabel;
    };

    getStatusRowClassName = () => {
        let routerState = this.getRouterState();
        const {proxyDeliveryForPackageReceivedList} = this.state;
        let isRowStatus = false;
        if (
            routerState.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE &&
            !proxyDeliveryForPackageReceivedList.eta
        ) {
            isRowStatus = true;
        } else if (
            routerState.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING ||
            routerState.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE
        ) {
            isRowStatus = true;
        } else if (
            routerState.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE &&
            proxyDeliveryForPackageReceivedList.eta &&
            !proxyDeliveryForPackageReceivedList.carrierName
        ) {
            isRowStatus = true;
        }
        return isRowStatus;
    };

    render() {
        const {F1OrderDetails, queryKey, statusOptions} = this.props;
        const {
            proxyDeliveryForPackageReceivedList,
            f1WaitShippedList,
            packageStatus,
            f1PackageReceivePageLoad,
            cancelReceivePackageDialogOpened,
            trackAndTraceLogsArry,
            receivePackageRemark,
            chooseImage,
            uploadFileBtnIsLoading,
            signReceiptUploadDialogOpened,
            rejectPackageDialogOpened,
            rejectReasonOptions,
            rejectDialogResetKey,
        } = this.state;
        const uploadDisabled = false;
        const onChooseImage = this.onChooseImage;
        const onSelectedImage = this.onSelectedImage;
        const inputRef = this.inputFileRef;

        let checkedQuantity =
            this.getReceivePackageQuantity() && !this.isDisabledReceiveBtn();
        if (F1OrderDetails.orderProducts) {
            for (let n = 0; n < F1OrderDetails.orderProducts.length; n++) {
                F1OrderDetails.orderProducts[n]['checked'] = true;
            }
        }
        let routerState = this.getRouterState();
        console.log('routerState in render:', routerState.tabFlag);

        const customerReceiveConfirmSegments =
            this.formatCustomerReceiveConfirmText(
                T('proxy_delivery_package_customer_receive_confirm_text'),
            );

        return (
            <div className="proxy-delivery-package-container">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <p className="header-order-number">
                        {T('proxy_delivery_order_management_order_number')}{' '}
                        <span className="numer">{routerState.orderNumber}</span>
                    </p>
                    <div className="header-search-input">
                        <SearchInput
                            title="queryKey"
                            value={queryKey}
                            placeholder={T('enter_sku')}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>

                {f1PackageReceivePageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : JSON.stringify(proxyDeliveryForPackageReceivedList) ===
                  '{}' ? (
                    <div className="no-data-container">
                        <div className="no-data-icon-wrapper">
                            <div className="no-data-icon"></div>
                        </div>
                        <h3 className="no-data-title">
                            {T('proxy_delivery_package_detail_not_found')}
                        </h3>
                        <p className="no-data-subtitle">
                            {T(
                                'proxy_delivery_package_detail_not_found_message',
                            )}
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="package-receive-order-header">
                            <div className="f1-order-container">
                                <p className="header-order-number">
                                    <label className="header-value">
                                        {T('fone_order_dn_number')}
                                    </label>
                                    <span className="order-numer">
                                        {
                                            proxyDeliveryForPackageReceivedList.shipmentNumber
                                        }
                                    </span>
                                </p>
                                <div className="f1-order">
                                    <label className="header-value">
                                        {T('fone_order_branch_name')}
                                    </label>
                                    <span className="f1-order-numer-value">
                                        {
                                            proxyDeliveryForPackageReceivedList.branchName
                                        }
                                    </span>
                                </div>
                            </div>

                            <div
                                className="proxy-delivery-package-content"
                                style={{display: 'flex'}}>
                                <div
                                    className="package-create-time"
                                    style={{width: '50%'}}>
                                    <label className="header-value">
                                        {T(
                                            'proxy_delivery_order_list_create_time',
                                        )}
                                    </label>
                                    <span className="proxy-delivery-package-value">
                                        {
                                            proxyDeliveryForPackageReceivedList.orderDate
                                        }
                                    </span>
                                </div>
                                {routerState.tabFlag ===
                                    PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE &&
                                proxyDeliveryForPackageReceivedList.eta ? (
                                    <div
                                        className="estimated-delivery-time"
                                        style={{
                                            width: '50%',
                                            paddingLeft: '0rem',
                                        }}>
                                        <label className="header-value">
                                            {T(
                                                'proxy_delivery_order_list_estimated_delivery_time',
                                            )}
                                        </label>
                                        <span className="proxy-delivery-package-value">
                                            {
                                                proxyDeliveryForPackageReceivedList.eta
                                            }
                                        </span>
                                    </div>
                                ) : (
                                    proxyDeliveryForPackageReceivedList.carrierName && (
                                        <div className="f1-carrier-name-container">
                                            <div
                                                className="header-order-number"
                                                style={{
                                                    padding: '0 0rem 0.7rem',
                                                    display: 'initial',
                                                    lineHeight: '1.5',
                                                }}>
                                                <label className="header-value">
                                                    {T(
                                                        'host_logistics_company',
                                                    )}
                                                </label>
                                                <span className="carrier-name-value">
                                                    {
                                                        proxyDeliveryForPackageReceivedList.carrierName
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                            {
                                <div className="proxy-delivery-carrier-status-container">
                                    {routerState.tabFlag ===
                                        PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE &&
                                        proxyDeliveryForPackageReceivedList.eta &&
                                        proxyDeliveryForPackageReceivedList.carrierName && (
                                            <div
                                                className="proxy-delivery-row"
                                                style={{display: 'initial'}}>
                                                <label className="header-value proxy-delivery-carrier-label">
                                                    {T(
                                                        'host_logistics_company',
                                                    )}
                                                </label>
                                                <span className="carrier-name-value proxy-delivery-carrier-value">
                                                    {
                                                        proxyDeliveryForPackageReceivedList.carrierName
                                                    }
                                                </span>
                                            </div>
                                        )}

                                    <div
                                        className={
                                            this.getStatusRowClassName()
                                                ? 'proxy-delivery-status-row status-contanier'
                                                : 'proxy-delivery-status-row'
                                        }>
                                        <label className="header-value proxy-delivery-status-label">
                                            {T(
                                                'proxy_delivery_shipment_status',
                                            )}
                                        </label>
                                        <span className="carrier-name-value proxy-delivery-status-value">
                                            {this.getTabStatusLabel()}
                                        </span>
                                    </div>
                                </div>
                            }

                            {/* 订单地址在三个代配送详情页签都展示，后端无地址时保持不显示。 */}
                            {proxyDeliveryForPackageReceivedList.receiverAddress && (
                                <div className="proxy-delivery-remark-row">
                                    <label className="header-value proxy-delivery-remark-label">
                                        {T('shippingAddress')}
                                    </label>
                                    <div className="proxy-delivery-remark-value">
                                        {
                                            proxyDeliveryForPackageReceivedList.receiverAddress
                                        }
                                    </div>
                                </div>
                            )}

                            {proxyDeliveryForPackageReceivedList.stRemark &&
                                (routerState.tabFlag ===
                                    PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING ||
                                    proxyDeliveryForPackageReceivedList.status ===
                                        PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED) && (
                                    <div className="proxy-delivery-remark-row">
                                        <label className="header-value proxy-delivery-remark-label">
                                            {T('proxy_delivery_shipto_remark')}
                                        </label>
                                        <div className="proxy-delivery-remark-value">
                                            {
                                                proxyDeliveryForPackageReceivedList.stRemark
                                            }
                                        </div>
                                    </div>
                                )}

                            {routerState.tabFlag ===
                                PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE &&
                            trackAndTraceLogsArry.length > 0 ? (
                                <div className="contract-operate_recodeMain">
                                    <ul className="contract-operate_recode_date">
                                        {trackAndTraceLogsArry.map(
                                            (trackingItem, index) => (
                                                <li
                                                    key={`${
                                                        trackingItem.eventTime ||
                                                        index
                                                    }-${index}`}>
                                                    <i></i>
                                                    <div className="spanList">
                                                        <div className="tracking-left">
                                                            <div className="tracking-event-description">
                                                                {
                                                                    trackingItem.eventDescription
                                                                }
                                                            </div>
                                                            {trackingItem.eventLocation ? (
                                                                <span className="tracking-location">
                                                                    {
                                                                        trackingItem.eventLocation
                                                                    }
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                        <div className="tracking-right">
                                                            <span className="tracking-time">
                                                                {
                                                                    trackingItem.eventTime
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </div>
                            ) : null}

                            {proxyDeliveryForPackageReceivedList.histories &&
                                proxyDeliveryForPackageReceivedList.histories
                                    .length > 0 && (
                                    <ProxyDeliveryStatusTracking
                                        previewSignReceiptImage={
                                            this.previewSignReceiptImage
                                        }
                                        historyStatusList={
                                            proxyDeliveryForPackageReceivedList.histories
                                        }
                                        rejectReasonOptions={
                                            rejectReasonOptions
                                        }
                                        statusOptions={statusOptions}
                                    />
                                )}
                        </div>

                        <div className="on-the-go-package-container">
                            <ul className="f1-shippment-wait-shipped">
                                {JSON.stringify(f1WaitShippedList) !== '{}' &&
                                f1WaitShippedList.waitShipSkus.length > 0
                                    ? f1WaitShippedList.waitShipSkus.map(
                                          (waitShipItem, waitShipIndex) => (
                                              <li key={waitShipIndex}>
                                                  <div className="first-row">
                                                      <div className="wait-shipped-sku">
                                                          {T(
                                                              'host_product_sku',
                                                          )}
                                                          <span className="sku-value">
                                                              {waitShipItem.sku}
                                                          </span>
                                                      </div>
                                                      <span className="f1-wait-shipped-quantity">
                                                          {T(
                                                              'host_wait_quantity',
                                                          )}
                                                          <span className="sku-quantity">
                                                              {
                                                                  waitShipItem.quantity
                                                              }
                                                          </span>
                                                      </span>
                                                  </div>
                                              </li>
                                          ),
                                      )
                                    : null}
                            </ul>

                            <ProxyDeliveryReceivePackageCard
                                f1PackageReceive={
                                    proxyDeliveryForPackageReceivedList
                                }
                                packageStatus={
                                    packageStatus
                                }></ProxyDeliveryReceivePackageCard>
                        </div>

                        {
                            <div className="footer-wrap">
                                <div className="footer clearfix container-max-width is-fixed">
                                    {
                                        <>
                                            {routerState.tabFlag !==
                                                PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE && (
                                                <BasicButton
                                                    className="proxy-delivery-package-reject-btn pull-left"
                                                    type="default"
                                                    disabled={
                                                        this.isDisabledReceiveBtn() ||
                                                        checkedQuantity <= 0
                                                    }
                                                    onClickOfSingleTap={
                                                        this
                                                            .openRejectPackageDialog
                                                    }>
                                                    {T('proxy_delivery_reject')}
                                                </BasicButton>
                                            )}

                                            {proxyDeliveryForPackageReceivedList.status !==
                                                PROXY_DELIVERY_ORDER_STATUS.COMPLETED && (
                                                <BasicButton
                                                    className="proxy-delivery-package-receive-btn pull-right"
                                                    type="primary"
                                                    disabled={
                                                        checkedQuantity > 0
                                                            ? false
                                                            : true
                                                    }
                                                    onClickOfSingleTap={
                                                        this.allReceivePackage
                                                    }>
                                                    {this.getReceiveLabel()}
                                                </BasicButton>
                                            )}
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </>
                )}

                <Dialog
                    opened={rejectPackageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('rejectPackageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <ProxyDeliveryReject
                        key={`reject-dialog-${rejectDialogResetKey}`}
                        uploadFileBtnIsLoading={uploadFileBtnIsLoading}
                        rejectReasonOptions={rejectReasonOptions}
                        onReject={this.handleRejectPackage}
                        onClose={() =>
                            this.dialogDidClose('rejectPackageDialogOpened')
                        }
                    />
                </Dialog>

                <Dialog
                    opened={cancelReceivePackageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelReceivePackageDialogOpened')
                    }
                    options={{bgClickClose: !uploadFileBtnIsLoading}}>
                    <div className="uploa-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {this.getDialogTitle(routerState)}
                        </h5>
                        {(routerState.tabFlag ===
                            PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE ||
                            proxyDeliveryForPackageReceivedList.status ===
                                PROXY_DELIVERY_ORDER_STATUS.HOST_REJECTED) && (
                            <p className="upload-method-host-receive-subtitle text-center">
                                {T(
                                    'proxy_delivery_package_host_receive_confirm_text',
                                )}
                            </p>
                        )}
                        {(routerState.tabFlag ===
                            PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING ||
                            proxyDeliveryForPackageReceivedList.status ===
                                PROXY_DELIVERY_ORDER_STATUS.CUSTOMER_REJECTED) && (
                            <div
                                className={`upload-method-customer-receive-subtitle text-center${
                                    receivePackageRemark
                                        ? ''
                                        : ' upload-method-customer-receive-subtitle--default'
                                }`}>
                                {receivePackageRemark ? (
                                    <div className="receive-st-remark">
                                        {receivePackageRemark}
                                    </div>
                                ) : (
                                    customerReceiveConfirmSegments.map(
                                        (segment, index) => (
                                            <p
                                                key={`customer-receive-tip-${index}`}>
                                                {segment.leading}
                                                {segment.highlight ? (
                                                    <>
                                                        <span className="upload-method-highlight">
                                                            {segment.highlight}
                                                        </span>
                                                        {segment.punctuation}
                                                    </>
                                                ) : (
                                                    segment.punctuation
                                                )}
                                            </p>
                                        ),
                                    )
                                )}
                            </div>
                        )}
                        <BaseImageUploader
                            className={util.getClassName({
                                'upload-method-upload': true,
                                disabled: uploadDisabled,
                            })}
                            onClickOfSingleTap={
                                uploadDisabled ? undefined : onChooseImage
                            }
                            disabled={uploadDisabled}>
                            {chooseImage && chooseImage.url ? (
                                <img src={chooseImage.url} alt="" />
                            ) : (
                                <>
                                    <span className="signature-method-upload-icon" />
                                    <span className="upload-method-upload-text">
                                        {T(
                                            'proxy_delivery_package_upload_photo',
                                        )}
                                    </span>
                                </>
                            )}
                            <input
                                ref={inputRef}
                                type="file"
                                accept="image/*"
                                onChange={
                                    uploadDisabled ? undefined : onSelectedImage
                                }
                                disabled={uploadDisabled}
                            />
                        </BaseImageUploader>
                        <div className="upload-method-actions receive-package-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                loading={uploadFileBtnIsLoading}
                                disabled={!chooseImage || !chooseImage.url}
                                onClickOfSingleTap={
                                    this.confirmReceivePackageHandle
                                }>
                                {T('order_confirm_receive')}
                            </BasicButton>
                            <BasicButton
                                type="default"
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'cancelReceivePackageDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={signReceiptUploadDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('signReceiptUploadDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="tag-preview-dialog">
                        <p id="testImage" className="text-center"></p>
                        <div className="tag-preview-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'signReceiptUploadDialogOpened',
                                    )
                                }>
                                {T('shopping_cart_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, proxyDelivery} = state;
    return {
        F1OrderDetails: host.F1OrderDetails,
        skuReplenishmentDetail: host.skuReplenishmentDetail,
        updateF1OrderList: host.updateF1OrderList,
        f1ShipmentWaitReceive: host.f1ShipmentWaitReceive,
        f1ShipmentWaitshipped: host.f1ShipmentWaitshipped,
        f1ShipmentReceived: host.f1ShipmentReceived,
        previewProxyDeliveryImage: host.previewProxyDeliveryImage,

        viewProxyDeliveryOrderPackageData:
            proxyDelivery.viewProxyDeliveryOrderPackageData,
        queryKey:
            proxyDelivery.proxyDeliveryPackageReceiveSearchfields.queryKey,
        statusOptions: proxyDelivery.statusOptions,
        rejectReasonList: proxyDelivery.rejectReasonList,
    };
};

const mapDispatchToProps = {
    openNotification,
    receiveProxyDeliveryPackage,
    viewOrderTracking,
    setProxyDeliveryOrderSource,
    uploadReceiveImage,

    viewProxyDeliveryPackage,
    clearProxyDeliveryPackageData,
    updateProxyDeliveryPackageReceiveSearchFileld,
    updateProxyDeliveryOrderTabActive,

    getSysDict,
    rejectProxyDeliveryPackage,
    getSysDictByRejectReason,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProxyDeliveryForPackageReceive);
